// 
export const INCO_TERMS_LIST = 'INCO_TERMS_LIST';
export const COUNTRY_LIST = 'COUNTRY_LIST';
export const UOM_TYPE_LIST = 'UOM_TYPE_LIST';
export const SALES_PERSON_LIST = 'SALES_PERSON_LIST';
export const DOCUMENT_TYPE_LIST = 'DOCUMENT_TYPE_LIST';
export const DOCUMENT_TYPE_PURCHASE_LIST = 'DOCUMENT_TYPE_PURCHASE_LIST';
export const DOCUMENT_TYPE_SALES_LIST = 'DOCUMENT_TYPE_SALES_LIST';
export const QUANTITY_TYPE_LIST = 'QUANTITY_TYPE_LIST';
export const COMMODITYGROUP = 'COMMODITYGROUP';
export const CONTAINER_TYPE_LIST = 'CONTAINER_TYPE_LIST';
export const OPERATOR_LIST = 'OPERATOR_LIST';
export const MOVE_TYPE = 'MOVE_TYPE';
export const CURRENCY_LIST = 'CURRENCY_LIST';
export const CHARGE_BASIS_LIST = 'CHARGE_BASIS_LIST';
export const UOM_LIST = 'UOM_LIST';
export const FILE_MANAGER_LIST = 'FILE_MANAGER_LIST';
export const STANDARD_TERMS_LIST = 'STANDARD_TERMS_LIST';
export const MASTER_COMPANY_DETAIL = 'MASTER_COMPANY_DETAIL';
export const CHARGES_DESCRIPTION_LIST = 'CHARGES_DESCRIPTION_LIST';
export const ACCOUNT_ADDRESSBOOK_MODULE_LIST = 'ACCOUNT_ADDRESSBOOK_MODULE_LIST';
export const ACCOUNT_ADDRESSBOOK_BASIS_LIST = 'ACCOUNT_ADDRESSBOOK_BASIS_LIST';
export const CARRIER_LIST = 'CARRIER_LIST';
export const OFFICE_TYPE = 'OFFICE_TYPE';
export const PROFIT_CENTER = 'PROFIT_CENTER';
export const PACKAGE_TYPE = 'PACKAGE_TYPE';
export const MANUFACTURER_LIST = 'MANUFACTURER_LIST';
export const NOTES_TYPE = 'NOTES_TYPE';
export const BL_TYPE_LIST = 'BL_TYPE_LIST';
export const CLOADER_LIST = 'CLOADER_LIST';


